export default {
  ImportarFotoPerfilFacebook: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "importar-foto-perfil-facebook"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/ImportarFotoPerfilFacebook.js
// module id = qgR9
// module chunks = 32